define(['baseApi', 'proxyService', 'base64'], function(baseApi, proxyService, base64) {
  'use strict';
  /**
  * 创建模板服务模块
  */
  var DataServices = function() {
    this.init();
  };

  DataServices.prototype = {
    constructor: DataServices,

    init: function() {
      this.dataServices = [];
    },

    add: function(name, url, dataMap, action) {
      this.dataServices[name] = new CURD(url, dataMap, action);
    },

    get: function(name) {
      return this.dataServices[name];
    }
  };

  var CURD = function(url, dataMap, action) {
    this.action = $.extend(true, {}, action);
    this.params = {url: url, timeout: 10000, data: {}};
    this.dataMap = dataMap;
    this.init();
  };

  CURD.prototype = {
    constructor: CURD,

    init: function() {
      for (var x in this.action) {
        this[x] = function(type) {
          return function(params){
            return this.send(params, type);
          };
        }(x);
      }
    },

    //发送信息
    send: function(params, type) {
      var dfd;
      var _params = $.extend(true, {}, this.params, this.action[type], params);

      for (var x in this.dataMap) {
        if (_params.hasOwnProperty(x)) {
          var reg = new RegExp(':\\b' + x + '\\b');
          _params.url = _params.url.replace(reg, _params[x]);
        }
      }

      //get方法根据传参拼接url
      _params.head = _params.head || {};
      _params.head['X-Requested-With'] = 'XMLHttpRequest';

      if (_params.method === 'GET') {
        if (!$.isEmptyObject(_params.data)) {
          if (_params.url.indexOf('?') === -1) {
            _params.url += '?';
          }
          $.each(_params.data, function(k, v) {
            _params.url += k + '=' + v + '&';
          })
          _params.url = _params.url.substr(0, _params.url.length -1);
        }
      } else {
        if (_params.bJsonData) {
          _params.head['Content-Type'] = 'application/json; charset=utf8';
          _params.data = JSON.stringify(_params.data);
          _params.bRawData = true;
          delete _params.bJsonData;
        }
      }

      if (!baseApi.isWpsEnv()) {
        if (_params.method === 'GET') {
          dfd = proxyService.httpGet(_params, _params.head);
        } else {
          dfd = proxyService.httpPost(_params, _params.head);
        }
      } else {
        dfd = $.Deferred();
        var callback = 'jsCallback' + (new Date() - 0) + Math.ceil(Math.random() * 10000); // 精确到毫秒仍有可能出错, 加随机数保证
        window[callback] = function (res) {
          delete window[callback];
          res = JSON.parse(base64.decode(res));
          if (res && res.result) {
            switch (res.result.error_code) {
              case 'SUCCESS':
                try {
                  dfd.resolve(res.result.data);
                } catch (e) {
                  dfd.reject(3);
                }
                break;
              default:
                dfd.reject(res.result.error_code);
            }
          }
        }

        _params.callback = callback;

        if (_params.method === 'GET') {
          baseApi.httpGet(_params, _params.head);
        } else {
          baseApi.httpPost(_params, _params.head);
        }
      }

      return dfd;
    }
  };

  return {
    DataServices
  };
});



/** WEBPACK FOOTER **
 ** ./src/scripts/service/dataServicesBaseV2.js
 **/